<template>
  <div class="modal custom-modal fade" id="edit_contact" role="dialog" :showUpdate.sync="showUpdate">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit Contact</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <!-- <pre>{{ formUpdateContact }}</pre> -->
          <form @submit.prevent="updateContact">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="col-form-label">
                    First Name
                    <span class="text-danger">*</span>
                  </label>
                  <input v-model="formUpdateContact.first_name" class="form-control" type="text" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="col-form-label">Last Name</label>
                  <input v-model="formUpdateContact.last_name" class="form-control" type="text" />
                </div>
              </div>
            </div>
            <div class="form-group">
              <label>
                Email Address
                <!-- <span class="text-danger">*</span> -->
              </label>
              <input v-model="formUpdateContact.email" class="form-control" type="email" />
            </div>
            <div class="form-group">
              <label>
                Contact Number
                <span class="text-danger">*</span>
              </label>
              <input v-model="formUpdateContact.phone_number" class="form-control" type="text" />


            </div>
            <div class="form-group">
              <label>
                Birth Date
              </label>
              <div class="row"> 
                <div class="col-sm-4">
                  <div class="onoffswitch">
                    <input type="checkbox" v-model="formUpdateContact.birth_date_is_filled" name="onoffswitch" class="onoffswitch-checkbox" id="birth_date_is_filled_checkbox_update" />
                    <label class="onoffswitch-label" for="birth_date_is_filled_checkbox_update">
                      <span class="onoffswitch-inner"></span>
                      <span class="onoffswitch-switch"></span>
                    </label>
                  </div>
                </div>
                <div class="col-sm-8">
                  <input v-show="formUpdateContact.birth_date_is_filled == 1" v-model="formUpdateContact.birth_date_data"
                    class="form-control" type="date" />
                </div>
              </div>
            </div>
            <div class="form-group">
              <!-- {{formCreateContact}} -->
              <label class="d-block">Group</label>
              <div class="d-flex">
                <span class="input-group-text" id="basic-addon1"
                  ><i class="fa fa-search"></i
                ></span>
                <a-select
                    show-search
                    placeholder="Cari user"
                    :filter-option="false"
                    @focus="getGroupList('')"
                    mode="multiple"
                    @search="getGroupList"
                    v-model="formUpdateContact.list_id"
                  >
                    <a-select-option v-for="item in groupListArr" :key="item.id" :value="item.id">
                      {{ item.name }}
                    </a-select-option>
                    <template #notFoundContent>
                      <a-divider style="margin: 4px 0;" />
                      <div
                        style="padding: 4px 8px; cursor: pointer;"
                        @mousedown="e => e.preventDefault()"
                        @click="addNewGroup"
                      >
                        <a-icon type="plus" /> Add Group "{{ searchQuery }}"
                      </div>
                    </template>
                
                  </a-select>
              </div>
            </div>
            <div class="submit-section">
              <button class="btn btn-primary submit-btn">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import { formatFromUnixToDate } from "@/utils/helper"
export default {
  components: {
    Skeleton
  },
  data() {
    return {
      filter: '',
      loadingGroup: false,
      groupListParam: {
        name: "",
        page: 0,
        perPage: 1000
      },
      searchQuery: '',
      loading: false,
      birth_date_is_filled_checkbox: false,
      // formUpdateContact: {
      //   id: "",
      //   email: "",
      //   phone_number: "",
      //   first_name: "",
      //   last_name: "",
      //   list_id: [],
      //   birth_date_data: '',
      //   // birth_date_is_filled_checkbox: false,
      //   birth_date_is_filled: 0
      // }
    };
  },
  computed: {
    groupListArr() {
      return this.$store.state.contact.groupListArr;
    },
    selectedGroupArr() {
      return this.formUpdateContact.list_id.map((i) => {
        return { id: i };
      });
    },
    formUpdateContact: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    groupListFilterArr() {
      // Jika input pencarian kosong, tampilkan semua item
      if (!this.filter.trim()) {
        return this.groupListArr;
      }
      // Jika tidak, filter item berdasarkan pencarian
      return this.groupListArr.filter(item => {
        // Menggunakan metode 'LIKE' untuk pencarian yang mirip
        return item.name.toLowerCase().includes(this.filter.toLowerCase());
      });
    },
  },
  watch: {
    showUpdate: {
      handler: function (val, oldVal) {
        // console.log("val", val);
        // console.log("oldVal", oldVal);
        if (val != "") {
          // if (val.birth_date_is_filled == 1) {
          //   val.birth_date_is_filled_checkbox = true
          // } else{
          //   val.birth_date_is_filled_checkbox = false
          // }
          // this.viewContact(val);
          this.getGroupList();
        }
      },
      deep: true
    }
  },
  props: {
    filterContactListGroup: {
      type: Function
    },
    showUpdate: {
      type: String,
      default: ""
    },
    value: {
      type: Object,
      default: () => ({
        id: "",
        email: "",
        phone_number: "",
        first_name: "",
        last_name: "",
        list_id: [],
        birth_date_data: '',
        birth_date_is_filled: 0
      })
    }
  },
  methods: {   
    addNewGroup() {
      this.$store
        .dispatch("contact/createGroup", {
          name: this.searchQuery,
          description: "",
        })
        .then((response) => {
          this.$fire({
            title: "Success",
            text: "Group added successfully",
            type: "success",
            timer: 1000,
          });
          // this.getGroupList();
          this.formUpdateContact.list_id.push(response.id);
        });
    },
    toggleOnOff() {
      // console.log("before",this.formUpdateContact.birth_date_is_filled_checkbox)
      // this.formUpdateContact.birth_date_is_filled_checkbox = !this.formUpdateContact.birth_date_is_filled_checkbox
      this.birth_date_is_filled_checkbox = !this.birth_date_is_filled_checkbox
      // console.log("after",this.formUpdateContact.birth_date_is_filled_checkbox)
    },
    async getGroupList(param = null) {
      if (param !== null) {
        this.groupListParam.name = param;
        this.searchQuery = param;
      }
      this.loadingGroup = await false;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(async () => { 
        await this.$store
          .dispatch("contact/getGroupList", this.groupListParam) // sesuai kan dengan method di API
          .catch(error => {
            this.loadingGroup = false;
          });
      }, 300);
    },
    hasClass(element, className) {
      return (
        (" " + element.className + " ").indexOf(" " + className + " ") > -1
      );
    },
    resetSelected() {
      if (this.groupListArr.length > 0) {
        this.groupListArr.forEach(function (row, index) {
          // console.log("resetSelected", row);
          // if (this.hasClass("up-" + row.id, "completed")) {
          var element = document.getElementById("up-" + row.id);
          element.classList.remove("completed");
          // }
        });
      }
    }, 
    async updateContact() {
      // this.formUpdateContact.phone_number = this.formUpdateContact.phone_number.toString();

      // if (this.birth_date_is_filled_checkbox == true) {
      //   this.formUpdateContact.birth_date_is_filled = 1
      // } else {
      //   this.formUpdateContact.birth_date_is_filled = 0
      // }
      let formUpdateContact = {
        id: this.formUpdateContact.id,
        email: this.formUpdateContact.email,
        phone_number: this.formUpdateContact.phone_number.toString(),
        first_name: this.formUpdateContact.first_name,
        last_name: this.formUpdateContact.last_name,
        list_id: this.selectedGroupArr,
        birth_date_data: this.formUpdateContact.birth_date_data,
        birth_date_is_filled: this.formUpdateContact.birth_date_is_filled ? 1 :0 ,
      }
      await this.$store
        .dispatch("contact/updateContact", formUpdateContact)
        .then(response => {
          // this.formUpdateContact.list_id.forEach((value, index) => {
          //   var element = document.getElementById(value.id);
          //   element.classList.remove("completed");
          // });
          // this.formUpdateContact = {
          //   id: "",
          //   email: "",
          //   phone_number: "",
          //   first_name: "",
          //   last_name: "",
          //   list_id: []
          // };

          this.$fire({
            title: "Success",
            text: "Data updated successfully",
            type: "success",
            timer: 1000
          }).then(r => {
            this.filterContactListGroup();
          });
        });
      // .catch(error => {
      //   console.log("errrrrr", error);
      //   this.$fire({
      //     title: "Error",
      //     text: error.msg,
      //     type: "error",
      //     timer: 1000
      //   }).then(r => {});
      // });
    },
    async selectGroup(id) {
      let dataFormList={id:id}

      // console.log("dataFormList", dataFormList);
      // console.log("selgr", id);
      // console.log("this.formUpdateContact.list_id", this.formUpdateContact.list_id);
      var element = document.getElementById("up-" + id);
      if (this.formUpdateContact.list_id.length > 0) {
        var isFound = false;
        var indexFound = -1;
        await this.formUpdateContact.list_id.forEach((value, index) => {
          if (value.id === id) {
            indexFound = index;
          }
        });

        if (indexFound >= 0) {
          element.classList.remove("completed");
          this.formUpdateContact.list_id.splice(indexFound, 1);
        } else {
          // this.$refs
          element.classList.add("completed");
          // this.formUpdateContact.list_id.push(id);
          this.formUpdateContact.list_id.push(dataFormList);
        }
      } else {
        element.classList.add("completed");
        // this.formUpdateContact.list_id.push(id);
        this.formUpdateContact.list_id.push(dataFormList);
      }
    }
  },
  async created() { },
  async mounted() { },
  name: "update-contacts"
};
</script>


// WEBPACK FOOTER //
// src/views/contacts/updateContactV2.vue